function contactPageLoaded() {

	jQuery(window).load(function() {
		loading_screen.finish();
	});

	jQuery('.contacts-animate').each(function(i) {

		jQuery(this).delay(1500 + (200 * i)).fadeTo('600', 1);
	});
}